'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { reportWebVitals } from '@/lib/analytics';

export function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    reportWebVitals({
      id: metric?.id,
      name: metric?.name,
      value: metric?.value,
      delta: metric?.delta,
      rating: metric?.rating,
    });
  });

  return null;
}

export default WebVitalsReporter;